/* eslint-disable react/no-unknown-property */
import { OrbitControls, useAnimations, useGLTF } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';

// import CustomEscene from "@assets/models/ax.gltf";
import { Suspense, useEffect, useRef } from 'react';
import { useUserWatcher } from 'src/hooks/userWatcher';
const modelPath = '/models/loli.glb';
const Model = (props: any) => {
  const group = useRef();
  const { nodes, materials, animations }: any = useGLTF(modelPath);
  const { actions } = useAnimations(animations, group);

  useEffect(() => {
    if (props.isUserScrolling) {
      actions['CINEMA_4D___']?.play();
    } else {
      actions['CINEMA_4D___']?.stop();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isUserScrolling]);

  return (
    <group ref={group} {...props} rotation={[0, props.rotation, 0]} dispose={null}>
      <group name="Sketchfab_Scene">
        <group name="Sketchfab_model">
          <group name="86bc9d3f6d874bea96b5d0cde1fe4181fbx">
            <group name="Object_2">
              <group name="RootNode">
                <group name="Object_4">
                  <primitive object={nodes._rootJoint} />
                  <skinnedMesh
                    name="Object_7"
                    geometry={nodes.Object_7.geometry}
                    material={materials.body}
                    skeleton={nodes.Object_7.skeleton}
                  />
                  <skinnedMesh
                    name="Object_9"
                    geometry={nodes.Object_9.geometry}
                    material={materials.material}
                    skeleton={nodes.Object_9.skeleton}
                  />
                  <skinnedMesh
                    name="Object_11"
                    geometry={nodes.Object_11.geometry}
                    material={materials.body}
                    skeleton={nodes.Object_11.skeleton}
                    morphTargetDictionary={nodes.Object_11.morphTargetDictionary}
                    morphTargetInfluences={nodes.Object_11.morphTargetInfluences}
                  />
                  <skinnedMesh
                    name="Object_12"
                    geometry={nodes.Object_12.geometry}
                    material={materials.head}
                    skeleton={nodes.Object_12.skeleton}
                    morphTargetDictionary={nodes.Object_12.morphTargetDictionary}
                    morphTargetInfluences={nodes.Object_12.morphTargetInfluences}
                  />
                  <skinnedMesh
                    name="Object_13"
                    geometry={nodes.Object_13.geometry}
                    material={materials.biaoqing}
                    skeleton={nodes.Object_13.skeleton}
                    morphTargetDictionary={nodes.Object_13.morphTargetDictionary}
                    morphTargetInfluences={nodes.Object_13.morphTargetInfluences}
                  />
                  <skinnedMesh
                    name="Object_15"
                    geometry={nodes.Object_15.geometry}
                    material={materials.material}
                    skeleton={nodes.Object_15.skeleton}
                  />
                  <skinnedMesh
                    name="Object_17"
                    geometry={nodes.Object_17.geometry}
                    material={materials.hairA}
                    skeleton={nodes.Object_17.skeleton}
                  />
                  <skinnedMesh
                    name="Object_19"
                    geometry={nodes.Object_19.geometry}
                    material={materials.hairB}
                    skeleton={nodes.Object_19.skeleton}
                  />
                  <skinnedMesh
                    name="Object_21"
                    geometry={nodes.Object_21.geometry}
                    material={materials.HatAndShoues}
                    skeleton={nodes.Object_21.skeleton}
                  />
                  <skinnedMesh
                    name="Object_23"
                    geometry={nodes.Object_23.geometry}
                    material={materials.material}
                    skeleton={nodes.Object_23.skeleton}
                  />
                  <skinnedMesh
                    name="Object_25"
                    geometry={nodes.Object_25.geometry}
                    material={materials.cloth}
                    skeleton={nodes.Object_25.skeleton}
                  />
                  <skinnedMesh
                    name="Object_27"
                    geometry={nodes.Object_27.geometry}
                    material={materials.material}
                    skeleton={nodes.Object_27.skeleton}
                  />
                  <skinnedMesh
                    name="Object_29"
                    geometry={nodes.Object_29.geometry}
                    material={materials.cloth}
                    skeleton={nodes.Object_29.skeleton}
                  />
                  <group name="Object_6" position={[0, 68.099, -0.508]} />
                  <group name="Object_8" position={[0, 68.099, -0.508]} />
                  <group name="Object_10" position={[0, 68.099, -0.508]} />
                  <group name="Object_14" position={[0, 68.099, -0.508]} />
                  <group name="Object_16" position={[0.1, 143.699, -6.824]} />
                  <group name="Object_18" position={[0.1, 145.104, -6.835]} />
                  <group name="Object_20" position={[0, 82.592, -0.082]} rotation={[-0.403, 0, 0]} />
                  <group name="Object_22" position={[0, 82.592, -0.082]} rotation={[-0.403, 0, 0]} />
                  <group name="Object_24" position={[0, 92.812, -4.45]} />
                  <group name="Object_26" position={[0, 92.812, -4.45]} />
                  <group name="Object_28" position={[0, 92.812, -4.45]} />
                  <group name="Loli____">
                    <group name="body" position={[0, 68.099, -0.508]} />
                    <group name="body_1" position={[0, 68.099, -0.508]} />
                    <group name="head" position={[0, 68.099, -0.508]} />
                    <group name="head_1" position={[0, 68.099, -0.508]} />
                    <group name="hairA" position={[0.1, 143.699, -6.824]} />
                    <group name="hairB" position={[0.1, 145.104, -6.835]} />
                    <group name="HatAndShoues" position={[0, 82.592, -0.082]} rotation={[-0.403, 0, 0]} />
                    <group name="HatAndShoues_1" position={[0, 82.592, -0.082]} rotation={[-0.403, 0, 0]} />
                    <group name="cloth" position={[0, 92.812, -4.45]} />
                    <group name="cloth_1" position={[0, 92.812, -4.45]} />
                    <group name="skirt" position={[0, 92.812, -4.45]} />
                  </group>
                </group>
              </group>
            </group>
          </group>
        </group>
      </group>
    </group>
  );
};

const ModelLoader = ({ className }: { className?: string }) => {
  const { isUserScrolling, heightPosition } = useUserWatcher();

  const firstBreakPoint = 400;
  const secondBreakPoint = 800;
  const transitionRange = 200; // Range for smooth transition

  // Calculate position and rotation based on height
  const getModelPosition = () => {
    if (heightPosition < firstBreakPoint) {
      // Initial position (right side)
      return {
        translateX: 'calc(90vw - 100%)',
        rotation: 0
      };
    } else if (heightPosition < secondBreakPoint) {
      // First transition to left side
      const progress = Math.min(1, (heightPosition - firstBreakPoint) / transitionRange);
      return {
        translateX: `calc(${(1 - progress) * 10}vw - ${(1 - progress) * 10}%)`,
        rotation: 5
      };
    } else {
      // Second transition to right side
      const progress = Math.min(1, (heightPosition - secondBreakPoint) / transitionRange);
      return {
        translateX: `calc(${progress * 72}vw - ${progress * 10}%)`,
        rotation: 20
      };
    }
  };

  const { translateX, rotation } = getModelPosition();

  return (
    <div
      className={className}
      style={{
        position: 'absolute',
        transform: `translateX(${translateX})`,
        transition: 'transform 0.5s linear',
        top: 100 + heightPosition
      }}
    >
      <Canvas
        camera={{
          position: [0, 250, 300],
          fov: 50
        }}
      >
        <Suspense fallback={null}>
          <OrbitControls />
          <Model isUserScrolling={isUserScrolling} rotation={rotation} />
        </Suspense>
      </Canvas>
    </div>
  );
};
useGLTF.preload(modelPath);
export default ModelLoader;
